export default __webpack_public_path__ + "static/media/RapidThemeFullSize.4374fa6f.png";